exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.file-browser-toggle-tooltip .tooltip-inner {\n  max-width: none;\n}\n", ""]);

